import { cn } from "@/lib/utils";

export const STEPS = ["Role", "Assessment", "Publish", "Screening", "Interviews", "Offer"];
export const SECTIONS = ["build", "test", "publish", "screening", "interviews", "offer"];
export const sectionPath = (jobId, section) => `/recruiter/jobs/${jobId}/${section}`;

const DOT = { amber: "bg-amber-400", blue: "bg-sky-400", muted: "bg-muted-foreground/50", green: "bg-primary" };
const TEXT = { amber: "text-amber-700 dark:text-amber-300", blue: "text-sky-700 dark:text-sky-300", muted: "text-muted-foreground", green: "text-primary" };

export function LifecycleBar({ step = 1, className }) {
  return (
    <div className={cn("grid grid-cols-6 gap-1", className)} role="img" aria-label={`Step ${step} of 6 · ${STEPS[step - 1]}`} data-testid="lifecycle-bar">
      {STEPS.map((s, i) => <span key={s} className={cn("h-1 rounded-full", i < step - 1 ? "bg-primary" : i === step - 1 ? "bg-primary/40" : "bg-muted")} />)}
    </div>
  );
}

export function NextStep({ next, className, testId }) {
  if (!next) return null;
  return (
    <span className={cn("inline-flex items-center gap-2 text-sm", TEXT[next.tone], className)} data-testid={testId}>
      <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", DOT[next.tone])} />{next.label}
    </span>
  );
}

export const lifecycleCaption = (job) => {
  const lc = job?.lifecycle;
  if (!lc) return "";
  if (job.status !== "published") return `${lc.label} · draft`;
  return `${lc.label}${lc.day != null ? ` · day ${lc.day}` : ""}`;
};

const HUES = ["bg-sky-500/20 text-sky-700 dark:text-sky-200", "bg-violet-500/20 text-violet-700 dark:text-violet-200", "bg-emerald-500/20 text-emerald-700 dark:text-emerald-200", "bg-amber-500/20 text-amber-700 dark:text-amber-200", "bg-rose-500/20 text-rose-700 dark:text-rose-200"];

export function Initials({ name, className }) {
  const n = (name || "?").trim();
  const hue = HUES[[...n].reduce((a, c) => a + c.charCodeAt(0), 0) % HUES.length];
  return <span className={cn("h-8 w-8 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0", hue, className)} aria-hidden="true">{n.split(/\s+/).slice(0, 2).map((p) => p[0]).join("").toUpperCase()}</span>;
}

export const scoreTone = (s) => s == null ? "text-muted-foreground" : s >= 80 ? "text-primary" : s >= 65 ? "text-amber-600 dark:text-amber-300" : "text-rose-500 dark:text-rose-400";
